import React from 'react';
import { Card, CardTitle} from 'react-bootstrap';
import DateFnsFormat from 'date-fns/format';
import TotalSales from './TotalSales';
import WareHouseSales from './WareHouseSales';
import UnitsSoldCustomer from './UnitsSoldCustomer';
import {Link} from 'react-router-dom';


class CustomerInsights extends React.Component {
  constructor(props) {
    super(props)
  }


  render() {
   
    return(
      <Card className="CustomerInsights 2024" header="Customer Insights">
        <CardTitle>Customer Insights</CardTitle>
        <TotalSales id="all" title="All" />
        <div><UnitsSoldCustomer contactName="all" title="All Units Sold" /></div>
        <div><UnitsSoldCustomer contactName="B2DB" title="B2DB Units Sold" /></div>
        <div><UnitsSoldCustomer contactName="notbrakebidfood" title="Brakes and Bidfood Excluded" /></div>

        <TotalSales id="notbrakebidfood" title="Brakes and Bidfood Excluded" />
        <div><Link to={'/customerlist'}>See Key Customers</Link></div>
        <WareHouseSales contactName="all" title="All Customers" months="6" />
        <WareHouseSales contactName="notbrakebidfood" title="Not Brakes and Bidfood" months="6" />
    
        </Card>
      )
    }
  
}

export default CustomerInsights;
